<script setup>
import Icon from 'next/icon/Icon.vue';

defineProps({
  channel: { type: Object, required: true },
  disabled: { type: Boolean, default: false },
  unavailableLabel: { type: String, default: '' },
});

const emit = defineEmits(['select']);
</script>

<template>
  <button
    type="button"
    class="group flex h-full w-full items-start gap-3.5 rounded-2xl border border-n-weak bg-n-solid-1 p-4 text-left outline-none transition-all duration-200 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-n-solid-1 enabled:hover:-translate-y-px enabled:hover:border-[var(--channel-border)] enabled:hover:bg-[var(--channel-surface)] enabled:hover:shadow-sm disabled:cursor-not-allowed disabled:opacity-60 motion-reduce:transition-none motion-reduce:enabled:hover:translate-y-0"
    :style="{
      '--channel-border': `${channel.color}80`,
      '--channel-surface': `${channel.color}0D`,
      '--tw-ring-color': channel.color,
    }"
    :disabled="disabled"
    @click="emit('select', channel.key)"
  >
    <span
      class="flex size-11 shrink-0 items-center justify-center rounded-xl text-white shadow-sm"
      :style="{ backgroundColor: channel.color }"
    >
      <Icon :icon="channel.icon" class="size-[22px]" />
    </span>

    <span class="flex min-w-0 flex-1 flex-col">
      <span class="flex items-center justify-between gap-2">
        <span class="truncate text-sm font-semibold text-n-slate-12">
          {{ channel.title }}
        </span>
        <Icon
          v-if="!disabled"
          icon="i-hugeicons-arrow-right-01"
          class="size-4 shrink-0 text-n-slate-10 transition-transform group-hover:translate-x-0.5 group-hover:text-n-slate-12 motion-reduce:transition-none"
        />
        <span
          v-else-if="unavailableLabel"
          class="shrink-0 rounded-full bg-n-alpha-2 px-2 py-0.5 text-[11px] font-medium text-n-slate-11"
        >
          {{ unavailableLabel }}
        </span>
      </span>
      <span class="mt-1 text-[13px] leading-5 text-n-slate-11">
        {{ channel.description }}
      </span>
      <span
        v-if="channel.hint"
        class="mt-2.5 inline-flex w-fit items-center gap-1.5 rounded-md bg-n-alpha-1 px-2 py-0.5 text-[11px] font-medium text-n-slate-11"
      >
        <Icon :icon="channel.hintIcon" class="size-3.5" />
        {{ channel.hint }}
      </span>
    </span>
  </button>
</template>
